import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Layout from 'components/Layout'
import RevenueCenters from 'components/RevenueCenters'
import ListFilters from 'components/RevenueCenters/ListFilters'

import {
  loadAvailaibility,
  loadPaginatedAndFilteredRevenueCenters,
} from 'store/RevenueCenters/actions'
import { setRevenueCenterOptimisticListImage } from 'store/RevenueCenters/actions'
import { loadMenus } from 'store/Menus/actions'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import useEmailAuth from 'hooks/useEmailAuth'
import { getQueryStringParameters } from 'store/AppState/selector'
import { loadConfigurationModels } from 'store/ConfigurationModels/actions'
import useResetHistoryStateValue from 'hooks/useResetHistoryStateValue'

const RevenueCentersPage = () => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const resetHistoryStateValue = useResetHistoryStateValue(
    'updatedResourceUuid'
  )

  const venueUuid = useSelector((state) => getCurrentVenueUuid(state))
  const isVenueNexter = useEmailAuth()
  const queryStringParameters = useSelector((state) =>
    getQueryStringParameters(state, pathname)
  )

  const params = {
    venueUuid,
    includeSettings: isVenueNexter,
    ...queryStringParameters,
  }

  useEffect(() => {
    // reset the `updatedResourceUuid` in the location state
    // to ensure that the displayed image is downloaded from the source
    // rather than being retrieved from redux storage, where it might not exist.
    // In this case without reseting state when user uploads a new image and refreshes the page,
    // the image doesn't exist in the redux store, but updatedResourceUuid is set
    // so there is no image to display from store.
    resetHistoryStateValue('updatedResourceUuid')

    dispatch(loadAvailaibility(venueUuid))
    dispatch(loadPaginatedAndFilteredRevenueCenters(params))
    dispatch(loadMenus(venueUuid, isVenueNexter))
    dispatch(loadConfigurationModels())

    return () => dispatch(setRevenueCenterOptimisticListImage({}))
  }, [dispatch, venueUuid, isVenueNexter])

  return (
    <Layout
      isSidebar
      title="Revenue Centers"
      mainContent={<RevenueCenters queryStringParameters={params} />}
      navbarContent={<ListFilters queryStringParameters={params} />}
    />
  )
}

export default RevenueCentersPage
